<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>分销推广</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/distribution/personnel' }">推广人员</el-breadcrumb-item>
        <el-breadcrumb-item>累计收益</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">累计收益</h2>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">数据列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="50px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="order_no"
            label="订单编号"
            width="170px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="goods_name"
            label="商品名称"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="text-align:left;">{{ scope.row.goods_name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="goods_type"
            label="商品类型"
            width="150px"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ formatRef_type(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_nickname"
            label="用户信息"
            width="150px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="order_amount"
            label="订单金额"
            width="150px"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.order_total_amount}}元
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="180px"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm:ss")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ statusRender(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="收益类型"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.parent_level==1?'邀请奖励':'推广佣金'}}
            </template>
          </el-table-column>
          <el-table-column
            label="收益金额"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.amount}}元
            </template>
          </el-table-column>
          <el-table-column
            label="收益状态"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                type="danger"
                size="mini"
                v-if="scope.row.status==0"
              >待结算</el-tag>
              <el-tag
                size="mini"
                v-if="scope.row.status==1"
              >已结算</el-tag>
              <el-tag
                type="info"
                size="mini"
                v-if="scope.row.status==2"
              >已撤销</el-tag>
              <el-tag
                type="success"
                size="mini"
                v-if="scope.row.status==3"
              >已提现</el-tag>
              <el-tag
                type="warning"
                size="mini"
                v-if="scope.row.status==4"
              >提现中</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import { profitlogs, } from "@/api/distribution";
export default {
  components: {

  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
        promoter_type: "1,2"
      },
      pageTotal: 10,
      results: [],
    };
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.query.uid = this.$route.query.id
      profitlogs(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    // 订单状态渲染
    statusRender(row) {
      const order_status = {
        0: "待支付",
        1: "已支付",
        2: "待发货",
        3: "待收货",
        4: "已完成",
        5: "已取消",
      };
      return order_status[row.order_status] || "";
    },
    formateStatus(row) {
      const order_status = {
        0: "待结算",
        1: "已结算",
        2: "已撤销",
        3: "已提现",
      };
      return order_status[row.status] || "";
    },
    formatRef_type(row) {
      const obj = {
        0: "无",
        1: "课程",
        2: "题库",
        3: "专栏",
        4: "资料",
        5: "文章",
        6: "学长",
        7: "联报",
      };
      return obj[row.goods_type] || "";
    },

  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
